module.exports = __webpack_public_path__ + "static/media/garage.fca618a6.svg";